"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportPayoutTinkoffResponseDto = void 0;
/**
 * Сведения об операциях внутри инькова (ссылки для перехода)
 */
class BillingApiReportPayoutTinkoffResponseDto {}
exports.BillingApiReportPayoutTinkoffResponseDto = BillingApiReportPayoutTinkoffResponseDto;
